import React from 'react';
import {StyledCard} from "../../../entities/goods/ui/card/style";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const CardSkeleton = () => {
    return (
        <StyledCard className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-skeleton')} style={{height: 300}}>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-media')}></div>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-content')}></div>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-bottom')}></div>
        </StyledCard>
    );
};

export default CardSkeleton;